import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {FlatMenuGroupEntry} from "./flat-menu";

@Component({
  selector: 'flat-menu-breadcrumb',
  standalone: false,
  template: `
  <a class="btn btn-primary btn-sm" (click)="moveLeft()"><i class="fa fa-arrow-circle-left"></i></a>
  <div #root class="breadcrumb flat-menu-breadcrumb">
    <a id="gg{{group.slug}}" href="#g{{ group.slug }}" class="flat-menu-breadcrumb-item"
       (click)="onClick($event, group.slug)"
       [class.active]="group.slug == selected"
       *ngFor="let group of groups">{{ group.name}}</a>
  </div>
  <a class="btn btn-primary btn-sm" (click)="moveRight()"><i class="fa fa-arrow-circle-right"></i></a>
  `
})

export class FlatMenuBreadcrumbComponent implements AfterViewInit, OnChanges {
  @Input() groups: FlatMenuGroupEntry[];
  @Input() selected: string;
  @Output() onSelect: EventEmitter<string> = new EventEmitter();

  @ViewChild('root') root: ElementRef<HTMLDivElement>;

  private grpIds = [];
  private grpOffsets= {};

  ngAfterViewInit() {
    // parent offset
    const parentOffset = this.root.nativeElement.getBoundingClientRect().left;
    let parentPadding = 0;
    for (let i=0; i<this.root.nativeElement.children.length; i++) {
      const el = this.root.nativeElement.children[i],
            grpId = el.id.substr(2),
            offset = el.getBoundingClientRect().left - parentOffset;
      if (i == 0) {
        parentPadding = offset;
      }
      this.grpIds.push(grpId);
      this.grpOffsets[grpId] = offset - parentPadding;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.scrollToGroup(this.selected);
  }

  onClick($event, slug) {
    this.scrollToGroup(slug);
    this.onSelect.emit(slug);
    $event.preventDefault();
  }

  scrollToGroup(selected: string) {
    if (this.grpOffsets.hasOwnProperty(selected)) {
        this.root.nativeElement.scrollLeft = this.grpOffsets[selected]; //.scrollTo({top: 0, left: offset, behavior: "smooth"});
    } else {
      // happens in initial phase if we set a group from anchor
      // IntersectionObserver will fix it later
      // console.warn("no element found", selected);
    }
  }

  moveLeft() {
    let idx = 0;
    if (this.selected) {
      idx = this.grpIds.indexOf(this.selected);
    }
    if (idx > 0) {
      const newGroup = this.grpIds[idx-1];
      this.scrollToGroup(newGroup);
      this.onSelect.emit(newGroup);
    }
  }

  moveRight() {
    let idx = 0;
    if (this.selected) {
      idx = this.grpIds.indexOf(this.selected);
    }
    if (idx+1 < this.grpIds.length) {
      const newGroup = this.grpIds[idx+1];
      this.scrollToGroup(newGroup);
      this.onSelect.emit(newGroup);
    }
  }

}
